/**
 * 写入剪贴板；非安全上下文或无 Clipboard API 时回退到 execCommand。
 */
export async function copyTextToClipboard(text: string): Promise<void> {
  const t = text.trim()
  if (!t) {
    throw new Error('无可复制内容')
  }
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(t)
    return
  }
  const ta = document.createElement('textarea')
  ta.value = t
  ta.setAttribute('readonly', 'true')
  ta.style.position = 'fixed'
  ta.style.left = '-9999px'
  document.body.appendChild(ta)
  ta.select()
  try {
    const ok = document.execCommand('copy')
    if (!ok) throw new Error('复制失败')
  } finally {
    ta.remove()
  }
}
